(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woddle-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('woddle-explorer')) {
    customElements.define('woddle-explorer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.points = [...this.querySelectorAll('[data-point]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.activeIndex = 0;
        if (!this.points.length || this.points.length !== this.panels.length) return;
        this.points.forEach((point, index) => {
          point.hidden = false;
          point.addEventListener('click', () => this.select(index), { signal: this.controller.signal });
          point.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let next = index;
            if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.points.length - 1;
            else next = (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + this.points.length) % this.points.length;
            this.select(next);
            this.points[next].focus();
          }, { signal: this.controller.signal });
        });
        const nextButton = this.querySelector('[data-next]');
        if (nextButton) {
          nextButton.hidden = false;
          nextButton.addEventListener('click', () => this.select((this.activeIndex + 1) % this.points.length), { signal: this.controller.signal });
        }
        this.classList.add('is-ready');
        this.select(0);
      }
      select(index) {
        this.activeIndex = index;
        this.points.forEach((point, position) => point.setAttribute('aria-pressed', String(position === index)));
        this.panels.forEach((panel, position) => { panel.hidden = position !== index; });
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.panels[index].getAnimations().forEach(animation => animation.cancel());
          this.panels[index].animate([{ opacity: .2, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 220, easing: 'ease-out' });
        }
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
